/** AP08 copy (one group per control; a ticket edits only its own file). */
export const ap08PtBr = {
  title: 'Efeitos da liquidação de pagamentos',
  description:
    'Pagamentos, retenções, descontos, juros e adiantamentos liquidados no período, cada um com o seu lançamento.',
  prerequisite: '',
  detail: {
    truncated:
      'Mostrando {{shown}} de {{count}} pendências. Os totais por natureza só aparecem quando a lista cabe inteira.',
    openBill: 'Abrir conta',
    awaiting_one: '{{count}} pagamento aguardando conciliação',
    awaiting_other: '{{count}} pagamentos aguardando conciliação',
    bill: 'Conta',
    payment: 'Pagamento',
    paidOn: 'Pago em',
    paymentStatus: { PAID: 'Pago, aguardando conciliação' },
    bankTransaction: 'Lançamento bancário',
    amountNote:
      'O valor do cabeçalho soma o pagamento bruto e seus descontos, juros e multas; mede volume, não o saldo contábil pendente.',
    tieOutSkipped_one: '{{count}} liquidação com cobertura parcial da alocação bancária',
    tieOutSkipped_other: '{{count}} liquidações com cobertura parcial da alocação bancária',
    skipReasons: {
      MISSING_LINK_AMOUNT: 'Valor do vínculo de liquidação ausente',
      MISSING_FOREIGN_ALLOCATION: 'Alocação em moeda estrangeira ausente',
      BANK_AMOUNT_MISSING: 'Valor do lançamento bancário ausente',
      BANK_CURRENCY_MISMATCH: 'Moeda do lançamento bancário diferente',
      MISSING_BANK_ALLOCATION: 'Alocação do pagamento composto ausente',
    },
  },
  reasons: {
    BANK_PAYMENT_NOT_POSTED: {
      title: 'Pagamentos bancários sem lançamento',
      item: 'pagamento conciliado sem lançamento',
    },
    CARD_PAYMENT_NOT_POSTED: {
      title: 'Pagamentos no cartão sem lançamento',
      item: 'pagamento no cartão sem lançamento',
    },
    ADVANCE_APPLICATION_NOT_POSTED: {
      title: 'Adiantamentos aplicados sem lançamento',
      item: 'adiantamento aplicado sem lançamento',
    },
    CREDIT_NOT_POSTED: {
      title: 'Créditos e estornos sem lançamento',
      item: 'crédito sem lançamento',
    },
    DISCOUNT_NOT_POSTED: {
      title: 'Descontos sem lançamento',
      item: 'desconto sem lançamento',
    },
    LATE_CHARGE_NOT_POSTED: {
      title: 'Juros e multas sem lançamento',
      item: 'juros ou multa sem lançamento',
    },
    WITHHOLDING_NOT_POSTED: {
      title: 'Retenções sem lançamento',
      item: 'retenção sem lançamento',
    },
    SETTLEMENT_UNALLOCATED: {
      title: 'Liquidações sem alocação',
      item: 'pagamento conciliado sem vínculo com o extrato',
    },
    SETTLEMENT_PARTIALLY_ALLOCATED: {
      title: 'Liquidações com alocação parcial',
      item: 'valor pago acima do valor alocado',
    },
    SETTLEMENT_OVER_ALLOCATED: {
      title: 'Liquidações com alocação a maior',
      item: 'valor alocado acima do valor pago',
    },
    COMPOUND_PAYMENT_MISMATCH: {
      title: 'Pagamentos compostos que não fecham',
      item: 'pagamentos do mesmo lançamento bancário não somam o valor do extrato',
    },
    other: {
      title: 'Outras pendências de liquidação',
      item: 'pendência de liquidação',
    },
  },
};

export const ap08En: typeof ap08PtBr = {
  title: 'Payment settlement effects',
  description:
    'Payments, withholdings, discounts, interest and advances settled in the period, each with its journal entry.',
  prerequisite: '',
  detail: {
    truncated:
      'Showing {{shown}} of {{count}} open items. Totals per nature only appear when the whole list fits.',
    openBill: 'Open bill',
    awaiting_one: '{{count}} payment awaiting reconciliation',
    awaiting_other: '{{count}} payments awaiting reconciliation',
    bill: 'Bill',
    payment: 'Payment',
    paidOn: 'Paid on',
    paymentStatus: { PAID: 'Paid, awaiting reconciliation' },
    bankTransaction: 'Bank transaction',
    amountNote:
      'The headline amount adds the gross payment and its discounts, interest and fines; it measures volume, not the pending ledger balance.',
    tieOutSkipped_one: '{{count}} settlement with partial bank-allocation coverage',
    tieOutSkipped_other: '{{count}} settlements with partial bank-allocation coverage',
    skipReasons: {
      MISSING_LINK_AMOUNT: 'Settlement link amount missing',
      MISSING_FOREIGN_ALLOCATION: 'Foreign-currency allocation missing',
      BANK_AMOUNT_MISSING: 'Bank transaction amount missing',
      BANK_CURRENCY_MISMATCH: 'Bank transaction currency differs',
      MISSING_BANK_ALLOCATION: 'Compound payment allocation missing',
    },
  },
  reasons: {
    BANK_PAYMENT_NOT_POSTED: {
      title: 'Bank payments without a journal entry',
      item: 'reconciled payment without a journal entry',
    },
    CARD_PAYMENT_NOT_POSTED: {
      title: 'Card payments without a journal entry',
      item: 'card payment without a journal entry',
    },
    ADVANCE_APPLICATION_NOT_POSTED: {
      title: 'Applied advances without a journal entry',
      item: 'applied advance without a journal entry',
    },
    CREDIT_NOT_POSTED: {
      title: 'Credits and refunds without a journal entry',
      item: 'credit without a journal entry',
    },
    DISCOUNT_NOT_POSTED: {
      title: 'Discounts without a journal entry',
      item: 'discount without a journal entry',
    },
    LATE_CHARGE_NOT_POSTED: {
      title: 'Interest and fines without a journal entry',
      item: 'interest or fine without a journal entry',
    },
    WITHHOLDING_NOT_POSTED: {
      title: 'Withholdings without a journal entry',
      item: 'withholding without a journal entry',
    },
    SETTLEMENT_UNALLOCATED: {
      title: 'Settlements without an allocation',
      item: 'reconciled payment not linked to the statement',
    },
    SETTLEMENT_PARTIALLY_ALLOCATED: {
      title: 'Partially allocated settlements',
      item: 'amount paid exceeds the allocated amount',
    },
    SETTLEMENT_OVER_ALLOCATED: {
      title: 'Over-allocated settlements',
      item: 'allocated amount exceeds the amount paid',
    },
    COMPOUND_PAYMENT_MISMATCH: {
      title: 'Compound payments that do not add up',
      item: 'payments of the same bank entry do not add up to the statement amount',
    },
    other: {
      title: 'Other settlement items',
      item: 'settlement item',
    },
  },
};
